import {put,takeLatest,call} from 'redux-saga/effects';
import * as authService from '../../../services/authService';
import {REGISTER,REGISTER_SUCCESS,REGISTER_ERROR} from '../../actions/auth';

function* registerSaga(action) {
  try {
    const data=yield call(authService.Register,action.payload);

    yield put({
      type: REGISTER_SUCCESS,
      payload: data,
    });
  } catch(error) {
    yield put({
      type: REGISTER_ERROR,
      error: error.data? error.data:error,
    });
  }
}

export function* registerWatcher() {
  yield takeLatest(REGISTER,registerSaga);
}
